export const apiEndpoint = `https://zeqvt7ltai.execute-api.us-east-1.amazonaws.com/prd`;
